import { render, staticRenderFns } from "./bankAccountsTable.vue?vue&type=template&id=ea3941a2&"
import script from "./bankAccountsTable.vue?vue&type=script&lang=ts&"
export * from "./bankAccountsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports